import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FIRM } from "../mock";

const HERO_VIDEO =
  "https://customer-assets-jai6qajn.emergentagent.net/job_newberry-wieters/artifacts/sdgdetzd_2348685_Charleston_South_Carolina_Royal_Caribbean_1280x720.mp4";

const Hero = () => {
  return (
    <section className="relative w-full h-[85vh] min-h-[600px] max-h-[900px] overflow-hidden">
      {/* Background video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={HERO_VIDEO}
        poster="/hero_poster.jpg"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      />
      {/* Poster fallback (behind video) */}
      <div
        className="absolute inset-0 bg-cover bg-center -z-10"
        style={{ backgroundImage: "url(/hero_poster.jpg)" }}
        aria-hidden="true"
      />
      {/* Darkening overlays for legibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-nw-navy-dark/85 via-nw-navy-dark/75 to-nw-navy-dark/90" />
      <div className="absolute inset-0 bg-black/55" />

      {/* Content */}
      <div className="relative h-full container-nw flex flex-col justify-center">
        <div className="max-w-4xl">
          <div className="fade-up text-white text-xs md:text-sm uppercase tracking-[0.4em] mb-6 drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)]">
            <span className="text-nw-gold-light">&bull;</span> Newberry Wieters{" "}
            <span className="text-nw-gold-light">&bull;</span> Charleston Roots{" "}
            <span className="text-nw-gold-light">&bull;</span> Statewide Reach
          </div>
          <h1 className="fade-up-delay-1 hero-title text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
            We Understand
            <br />
            <span className="italic text-nw-gold-light">How Both Sides</span>
            <br />
            Think.
          </h1>
          <p className="fade-up-delay-2 mt-8 text-white/90 text-base md:text-lg max-w-2xl leading-relaxed drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
            A Charleston litigation boutique firm focused on construction
            disputes, insurance coverage, and complex litigation throughout
            South Carolina.
          </p>
          <div className="fade-up-delay-3 mt-10 flex flex-wrap gap-4">
            <Link
              to="/attorneys"
              className="group inline-flex items-center gap-2 bg-nw-gold hover:bg-nw-gold-light text-nw-navy-dark px-7 py-4 text-xs font-bold uppercase tracking-[0.15em] transition-all"
            >
              Meet Our Attorneys
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-transparent border border-white/60 hover:border-white text-white hover:bg-white hover:text-nw-navy px-7 py-4 text-xs font-bold uppercase tracking-[0.15em] transition-all"
            >
              Request a Consultation
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white/95 to-transparent pointer-events-none" />
    </section>
  );
};

export default Hero;
